module.exports = __webpack_public_path__ + "static/media/Path 12.ac7cbe6c.svg";